import i18n from '../../../i18n';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Cloud, LogIn, LogOut, RefreshCw } from 'lucide-react';
import { EnvBadge } from './helpers';

export const StatusCard = ({
  status, tokens, sessionActive, sessionEnv,
  authenticating, onAuthenticate, onLogout, onRefresh,
}) => (
  <Card>
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Cloud className="h-5 w-5 text-blue-500" />
          <CardTitle className="text-base">{i18n.t('auto.misc2.ksefIntegrationStatus')}</CardTitle>
          <span className="text-xs text-gray-500">{i18n.t('auto.misc2.polishNationalElectronicInvoicingSystemKrajowy')}</span>
        </div>
        <EnvBadge env={sessionEnv} />
      </div>
    </CardHeader>
    <CardContent>
      {status ? (
        <div className="flex flex-wrap gap-6 text-sm mb-3">
          <div>
            <div className="text-xs text-gray-500 uppercase">{i18n.t('auto.misc2.nip')}</div>
            <div className="font-mono font-semibold">{status.nip || '—'}</div>
          </div>
          <div>
            <div className="text-xs text-gray-500 uppercase">{i18n.t('auto.misc2.authMethod')}</div>
            <div className="flex items-center gap-1">
              {status.token_configured ? <><span className="text-green-600">✓</span> {i18n.t('auto.misc2.tokenV2')}</> : '—'}
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-500 uppercase">{i18n.t('auto.misc2.session')}</div>
            <div className={`flex items-center gap-1 font-medium ${sessionActive ? 'text-green-600' : 'text-gray-400'}`}>
              {sessionActive ? i18n.t('auto.misc2.active') : i18n.t('auto.misc2.inactive')}
              {status?.active_token_name && sessionActive && (
                <span className="text-xs font-normal text-gray-500 ml-1">({status.active_token_name})</span>
              )}
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-500 uppercase">{i18n.t('auto.misc2.proxy')}</div>
            <div>{status.proxy_configured ? `Direct (${status.proxy_url})` : 'Direct'}</div>
          </div>
          <div>
            <div className="text-xs text-gray-500 uppercase">{i18n.t('auto.misc2.statistics')}</div>
            <div>{status.statistics?.invoices_uploaded || 0} uploaded, {status.statistics?.invoices_downloaded || 0} downloaded</div>
          </div>
        </div>
      ) : (
        <div className="text-sm text-gray-400">{i18n.t('auto.misc2.loadingStatus')}</div>
      )}
      <div className="flex gap-2">
        {!sessionActive
          ? <Button size="sm" onClick={() => onAuthenticate(tokens.length > 0 ? tokens[0].id : null)} disabled={authenticating} data-testid="ksef-auth-btn">
              <LogIn className="h-3.5 w-3.5 mr-1" />{authenticating ? i18n.t('auto.misc2.authenticating') : i18n.t('auto.misc2.authenticate')}
            </Button>
          : <Button size="sm" variant="outline" onClick={onLogout} data-testid="ksef-logout-btn">
              <LogOut className="h-3.5 w-3.5 mr-1" />{i18n.t('auto.misc2.endSession')}
            </Button>
        }
        <Button size="sm" variant="ghost" onClick={onRefresh} data-testid="btn-refresh">
          <RefreshCw className="h-3.5 w-3.5 mr-1" />{i18n.t('auto.misc2.refresh')}
        </Button>
      </div>
    </CardContent>
  </Card>
);
